import { render, staticRenderFns } from "./extra-shop-freigabe.vue?vue&type=template&id=5536f398&lang=pug&"
import script from "./extra-shop-freigabe.vue?vue&type=script&lang=js&"
export * from "./extra-shop-freigabe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports